import { render, staticRenderFns } from "./search-configurations-form.view.vue?vue&type=template&id=68024e8e&scoped=true"
import script from "./search-configurations-form.view.vue?vue&type=script&lang=ts"
export * from "./search-configurations-form.view.vue?vue&type=script&lang=ts"
import style0 from "./search-configurations-form.view.vue?vue&type=style&index=0&id=68024e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68024e8e",
  null
  
)

export default component.exports